import React, {useState, useContext, useEffect} from "react"
import { graphql, navigate } from "gatsby"
// import { StaticImage } from "gatsby-plugin-image"
import axios from "axios"
// import queryString from "query-string"
import { AppContext } from "../contexts"
import Layout from "../components/layoutBM"
import Plans from "../components/plans"
import Loader from "../components/loader"
import ErrorDialog from "../components/errorDialog"
// import format from "../utils/format"
import "react-datepicker/dist/react-datepicker.css";
import Slider from "../components/slider"
import SliderDesktop from "../components/sliderDesktopBM"
import SliderMobileBM from "../components/sliderMobileBM"
import lang from "../languages/bm"

export default ({data}) => {
  const state = useContext(AppContext)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  
  const mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  let maxDate = new Date()
  let minDate = new Date()
  let midDate = new Date()
  maxDate.setFullYear(maxDate.getFullYear() - 19)
  minDate.setFullYear(minDate.getFullYear() - 45)
  midDate.setFullYear(midDate.getFullYear() - 32)

  const selectPlan = (plan) => {
    state.setInsured({
      selectedPlan: plan.code
    })
    navigate('/details')
  }

  useEffect(() => {
    axios.post('/quote/home-now/', {})
      .then(function (response) {
        if (Array.isArray(response.data)) {
          state.setPlans(response.data)
        } else {
          setIsError(true)
        }
      })
      .catch(function (error) {
        setIsError(true)
      })
      .finally(() => {
        setIsLoading(false)
      });
  }, [])

  useEffect(() => {
    document.cookie = `lang=${lang.id}; path=/`
    state.setLanguage(lang.id)
  }, [])

  const banners = [ 
    //   {
    //     src: 'iphone',
    //     altText: 'Get Covered Get Apple!',
    //     header: '',
    //     product: '',
    //     caption: '',
    //     link:'#iphonesompo',
    //     scroll: true
    //   },
    {
      src: 'header',
      altText: 'SOMPO HomeNow',
      header: '',
      product: 'SOMPO Home',
      caption: 'Anda dilindungi. Adakah barangan peribadi anda juga dilindungi?',
      link:''
    },
  ];
   
  const bannerSources = {
    //   iphone: {
    //     mobile: data.mobileIphone,
    //     desktop: data.desktopIphone,
    //   },
    header: {
      mobile: '/homeNow/images/img-header-435.jpg',
      desktop: '/homeNow/images/img-header-1440.jpg',
      // mobile: data.mobileHeader,
      // desktop: data.desktopHeader,
    },
  }

  return (
    <Layout pageTitle="Berjaya Sompo" isLanding={true} lang={lang}>
        {/* <div className="main-banner cover">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-1">
                        <div className="tx-container">
                            <div className="tx-title bold">Sompo Home<span className="prod-name-italic">Now</span>
                            </div>
                            <div className="tx-subtitle">You are protected. Are your personal belongings protected too?</div>
                        </div>
                    </div>
                </div>
            </div>
      </div> */}
          <div className="btn-desktop_res">
      <SliderDesktop />
    </div>
		    <div className="btn-mobile_res">
      <SliderMobileBM />
    </div>
      <div className="main-form">
      <div className="plans">
        <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1 col-md-12">
                <div className="row">
                  <Plans plans={state.plans} selectPlan={selectPlan} lang={lang}/>
                </div>
              </div>
          </div>
        </div>
      </div>
      </div>
      {/*
      <div className="iphone_campaign" id="goldsompo" hidden={false}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-md-12 mb-2">
              <div className="title text-center">SOMPO HUAT 兔(to)gether Campaign</div>
              <div className="sub-title">
                <p className="mt-4 mb-3 sub-title">Celebrate this auspicious rabbit year together with Berjaya Sompo and stand a chance to win an auspicious TNG Ang Pow when you buy SOMPO HomeNow online. Each successive 20th successful purchase online will get a TNG Ang Pow worth RM50 from 3 Jan to 5 Feb 2023. 200 sets of TNG Ang Pows total worth RM10,000 are to be won. What are you waiting for? Buy your insurance online now and HUAT 兔(to)gether.</p>
              </div>
              <div className="col-md-10 offset-md-1 table-raya_wrapper">
                <table className="table-raya mt-3" width="100%" border="0" align="center" cellPadding="0" cellSpacing="0">
                  <tr>
                    <th align="left" valign="top"><strong>Products</strong></th>
                    <th align="center" valign="top"><strong>Total Winners</strong></th>
                    <th align="center" valign="top"><strong>Prize</strong></th>
                    <th align="center" valign="top"><strong>Selection Criteria</strong></th>
                  </tr>
                  <tr>
                    <td align="left" valign="top">SOMPO HomeNow</td>
                    <td align="center" valign="top">200</td>
                    <td align="center" valign="top">RM50 TNG Ang Pow</td>
                    <td align="center" valign="top">Every 20th successful transaction.</td>
                  </tr>
                </table>
              </div>
              <br />
              <div className="sub-title">
                <div className="sub-title mt-3">Campaign Prize: 200 X RM50 TNG Ang Pow</div>
                <div className="sub-title mt-3">Campaign Date: 3 Jan – 5 Feb 2023</div>
              </div>
              <div className="sub-title mt-3"> Follow these simple steps to participate in this campaign:</div>
              <div className="sub-title price_iphone row">
                <ul className="mt-3">
                  <li>
                    <span className="bold"> 1: </span> Buy or renew SOMPO HomeNow online.
                  </li>
                  <li>
                    <span className="bold"> 2: </span> Once the online purchase or renewal is completed, you will automatically be enrolled in this campaign
                  </li>
                </ul>
              </div>
              <br />
              <div className="sub-title mt-3">Note: Winners will be announced 3 weeks after the campaign has ended & TNG Ang Pow will be fulfilled via email within 3 weeks after the announcement.</div>
              <br />
              <div className="sub-title mt-3">Terms & Conditions apply.</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mt-4 offset-md-4">
              <a target="_blank" href="https://online.berjayasompo.com.my/SompoOnline/doc/Sompo%20Huat%20Together%20Campaign%20TCs.pdf" rel="noreferrer">
                <div className="btn btn-red ghost">
                  <div className="back"> Terms and conditions </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    */}
      
        <div className="container mt-5">
            <div className="row">
                <div className="text-center col-md-8 mb-5 offset-md-2">
                    <div className="page-title">
                        <h1 className="bold">{lang.benefitsGlance.title}
                        </h1>
                        <h5 className="mt-2 sub-title">{lang.benefitsGlance.desc}</h5>
                    </div>
                </div>
                <div className="col-md-4 col-6 mb-5 text-center ico-fr-benefits2">
          <div><img src={"/homeNow/images/img-low-annual-premium-bm.png"} alt="img-low-annual-premium-bm" /></div>
          <h5 className="bold">{lang.benefitsGlance.benefit1Title}</h5>
          <p className="benefit-tab">{lang.benefitsGlance.benefit1Desc}</p>
        </div>
        <div className="col-md-4 col-6 mb-5 text-center ico-fr-benefits">
          <div><img src={"/homeNow/images/img-household-goods.svg"} alt="img-household-goods" /></div>
          <h5 className="bold">{lang.benefitsGlance.benefit2Title}</h5>
          <p className="benefit-tab">{lang.benefitsGlance.benefit2Desc}</p>
        </div>
        <div className="col-md-4 col-6 mb-5 text-center ico-fr-benefits">
          <div><img src={"/homeNow/images/img-sum-insured.svg"} alt="img-sum-insured" /></div>
          <h5 className="bold">{lang.benefitsGlance.benefit3Title}</h5>
          <p className="benefit-tab">{lang.benefitsGlance.benefit3Desc}</p>
        </div>
                
            </div>
        </div>
        <div className="product-bg mt-5">
        <div className="container">
          <div className="row">
            <div className="text-center col-md-8 mb-5 offset-md-2">
              <div className="title ">{lang.moreInsurance.title}</div>
              <h2 className="mt-2 mb-5 sub-title">{lang.moreInsurance.desc}</h2>
            </div>
        
            <div className="col-md-4 mt-5">
              <div className="box">
                <div className="text-center ico-product"><img src={"/homeNow/images/ico-car-insurance.svg"} /></div>
                <div className="tx-product_title">{lang.moreInsurance.more1Title}</div>
                <div className="mt-3">
                  <ul>
                    <li>{lang.moreInsurance.more1Sub1}</li>
                    <li>{lang.moreInsurance.more1Sub2}</li>
                    <li>{lang.moreInsurance.more1Sub3}</li>
					<li><a href='https://online.berjayasompo.com.my/SompoMotor/bm/'>{lang.moreInsurance.more1Sub4_1}</a> {lang.moreInsurance.more1Sub4_2}</li>
                    <li>{lang.moreInsurance.more1Sub5}</li>
                  </ul>
                </div>
                <div className="button-boxBM">
                  <a href="https://online.berjayasompo.com.my/SompoMotor/bm/">
                    <button type="button" className="btn btn-sompo_primary red">{lang.moreInsurance.getQuote}</button>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-5">
              <div className="box mobile">
                <div className="text-center ico-product"><img src={"/homeNow/images/ico-motor-insurance.svg"} /></div>
                <h3 className="tx-product_title">{lang.moreInsurance.more2Title}</h3>
                <div className="mt-3">
                  <ul>
                    <li>{lang.moreInsurance.more2Sub1}</li>
                    <li>{lang.moreInsurance.more2Sub2}</li>
                    <li>{lang.moreInsurance.more2Sub3}</li>
                    <li>{lang.moreInsurance.more2Sub4}</li>
                  </ul>
                </div>
                <div className="button-boxBM">
                  <a href="https://online.berjayasompo.com.my/motorcycle/bm/">
                    <button type="button" className="btn btn-sompo_primary red">{lang.moreInsurance.getQuote}</button>
                  </a>
                </div>
              </div>
            </div>
            {/* <div className="col-md-4 mt-5">
              <div className="box mobile">
                <div className="text-center ico-product"><img src={"/homeNow/images/ico-cashnow.svg"} /></div>
                <h3 className="tx-product_title">Hospital Income Insurance</h3>
                <div className="mt-3">
                  <ul>
                    <li>Premium as low as RM0.31 per day.</li>
                    <li>Covid-10 coverage with up to RM5,000 lump sum hospital allowance.</li>
                    <li>Daily cash benefit up to a maximum of RM18,000.</li>
                    <li>Hassle-free sign-up process, no health declaration necessary.</li>
                  </ul>
                </div>
                <div className="button-boxBM">
                  <a href="https://online.berjayasompo.com.my/cashNow/">
                    <button type="button" className="btn btn-sompo_primary red">Get Quote</button>
                  </a>
                </div>
              </div>
          </div> */}
            <div className="col-md-4 mt-5">
              <div className="box mobile">
                <div className="text-center ico-product"><img src={"/homeNow/images/ico-travel-insurance.svg"} /></div>
                <h3 className="tx-product_title">{lang.moreInsurance.more3Title}</h3>
                <div className="mt-3">
                  <ul>
                    <li>{lang.moreInsurance.more3Sub1}</li>
                    <li>{lang.moreInsurance.more3Sub2}</li>
                    <li>{lang.moreInsurance.more3Sub3}</li>
                    <li>{lang.moreInsurance.more3Sub4}</li>
                  </ul>
                </div>
                <div className="button-boxBM">
                  <a href="https://online.berjayasompo.com.my/travel-insurance/insurans-perjalanan/">
                    <button type="button" className="btn btn-sompo_primary red">{lang.moreInsurance.getQuote}</button>
                  </a>
                </div>
              </div>
          </div>
             {/* <div className="col-md-4 mt-5">
              <div className="box mobile">
                <div className="text-center ico-product"><img src={"/homeNow/images/ico-travel-insurance.svg"} /></div>
                <div className="tx-product_title">Travel Insurance </div>
                <div className="mt-3">
                  <ul>
                    <li>Premium as low as RM1 per day.</li>
                    <li>Comprehensive coverage including personal accident, medical & travel inconveniences.</li>
                    <li>Multiple travel insurance plan options - single, group, family and annual plan.</li>
                    <li>24/7 & 365 days of worldwide travel assistance.</li>
                  </ul>
                </div>
                <div className="button-boxBM">
                  <a href="https://online.berjayasompo.com.my/travel-insurance/">
                    <button type="button" className="btn btn-sompo_primary red">Get Quote</button>
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="seo mt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <p className="title">{lang.homeNow.title}<span className="prod-name-italic">{lang.homeNow.now}</span> </p>
              <p className="mt-3">
              {lang.homeNow.desc1_1}<span className="prod-name-italic">{lang.homeNow.now}</span> {lang.homeNow.desc1_2}
              </p>
              <p className="mt-3">
              {lang.homeNow.desc2}
              </p>
              <p className="mt-3 mb-5">
              {lang.homeNow.desc3}
              </p>
            </div>
          </div>
        </div>
      </div>
      { isLoading && <Loader />}
      <ErrorDialog 
        isOpen={isError}
        toggle={() => setIsError(v => !v)}
        lang={lang}
      />
    </Layout>
  )
}

// export const query = graphql`
//   query {
//     mobileHeader: file(relativePath: { eq: "img-header-435.jpg" }) {
//       childImageSharp {
//         gatsbyImageData(layout: FULL_WIDTH)
//       }
//     },
//     desktopHeader: file(relativePath: { eq: "img-header-1440.jpg" }) {
//       childImageSharp {
//         gatsbyImageData(layout: FULL_WIDTH)
//       }
//     },
//   }
// `